import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Navigation.css';

const Navigation: React.FC = () => {
  const location = useLocation();

  const navItems = [
    //{ path: '/', label: 'Getting Started' },
    //{ path: '/integration-guide', label: 'Integration Guide' },
    { path: '/', label: 'Overview' },
    { path: '/quick-start-guide', label: 'Quick Start' },
    { path: '/implementation-list', label: 'Supported Blockchains' },
    //{ path: '/off-the-shelf', label: 'Off-the-Shelf Contracts' },
    { path: '/resources', label: 'Resources' },
  ];

  return (
    <nav className="main-navigation">
      <ul className="nav-list">
        {navItems.map((item) => (
          <li key={item.path} className="nav-item">
            <Link
              to={item.path}
              className={`nav-link ${location.pathname === item.path ? 'active' : ''}`}
            >
              {item.label}
            </Link>
          </li>
        ))}
      </ul>
    </nav>
  );
};

export default Navigation;

